<template>
  <div>
    <div v-if="showTrustGroupSearch">
      <v-row>
        <v-col>
          <h3 class="text-left mt-10">
            <strong>Link to a Trust Group</strong>
          </h3>
        </v-col>
      </v-row>
      <TrustGroupSearch
        class="mt-2"
        :secondary-button-text="'Cancel'"
        @found-trust-group="setTrustGroup($event)"
        @secondary-button-clicked="emit('canceled')"
      />
    </div>

    <div class="mt-10" v-if="showTrustGroup">
      <p class="mb-4">Found Trust Group:</p>
      <v-row>
        <v-col><b>Company name:</b> {{ trustGroup!.company.companyName }}</v-col>
        <v-col
          ><b>Organisation number:</b>
          {{ trustGroup!.company.organisationNumber }}</v-col
        >
      </v-row>
      <v-row>
        <v-col
          ><b>Operating country:</b>
          {{ trustGroup!.company.operatingCountryCode }}</v-col
        >
        <v-col><b>Trust group type:</b> {{ trustGroup!.trustGroupType }}</v-col>
      </v-row>
      <v-row v-if="trustGroup != undefined" justify="end" class="mt-5">
        <PPrimaryButton class="mb-5 mr-3" @click="linkTrustGroup"
          >Add user to Trust Group</PPrimaryButton
        >
      </v-row>
    </div>
  </div>
</template>

<script setup lang="ts">
import PPrimaryButton from "@/components/custom/buttons/PPrimaryButton.vue";
import { UserProfile } from "@/models/userProfile";
import TrustGroupSearch from "@/views/admin-view/TrustGroupSearch.vue";
import { ref, type Ref, computed } from "vue";
import { genericError } from "@/modules/utilities";
import { TrustGroup } from "@/models/trustGroup";
import { addMemberToTrustGroup } from "@/services/trustGroupAdminService";
import { AddTrustGroupUserDto } from "@/models/dto/addTrustGroupUserDto";
import { useSnackBarStore } from "@/stores/snackBarStore";

const snackbarStore = useSnackBarStore();

const trustGroup: Ref<TrustGroup | undefined> = ref(undefined);
const addTrustGroupUserDto = ref(new AddTrustGroupUserDto());
const showTrustGroupSearch = ref(true);
const showTrustGroup = computed(() => trustGroup.value != undefined);

const props = defineProps<{
  userProfile: UserProfile;
}>();

const emit = defineEmits<{
  (e: "linked"): void;
  (e: "canceled"): void;
}>();

const updatedUserProfile = ref(new UserProfile());

function setTrustGroup(updatedTrustGroup: TrustGroup | undefined): void {
  if (trustGroup == undefined) {
    snackbarStore.showError("No trust group found");
  }
  trustGroup.value = updatedTrustGroup;
}

async function linkTrustGroup() {
  updatedUserProfile.value = { ...props.userProfile };
  if (trustGroup.value?.id == undefined) {
    snackbarStore.showError("No trust group found");
  } else {
    await putUser();
  }
}

async function putUser() {
  try {
    if (trustGroup.value == undefined) {
      return;
    }
    addTrustGroupUserDto.value.email = updatedUserProfile.value.email;
    addTrustGroupUserDto.value.trustGroupId = trustGroup.value.id;
    await addMemberToTrustGroup(addTrustGroupUserDto.value);
    snackbarStore.showSuccess("Linked user to trust group");
    emit("linked");
  } catch (error) {
    snackbarStore.showError(genericError);
  }
}
</script>
